import { z } from 'zod';
import { BaseValidatorSchema } from '../base-validator-schema';

export const RequiredValidator = z.literal('required');
export type TRequiredValidator = z.infer<typeof RequiredValidator>;

export const RequiredValidatorParamsSchema = z.object({
  required: z.boolean(),
});

export type TRequiredValidatorParams = z.infer<typeof RequiredValidatorParamsSchema>;

export const RequiredValidatorSchema = BaseValidatorSchema.extend({
  type: RequiredValidator,
  value: RequiredValidatorParamsSchema.optional(),
});
